import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MarkdownWrapper from "@/components/markdownWrapper";
import MediaWrapper from "@/components/mediaWrapper";
import LinkWrapper from "@/components/linkWrapper";

export const query = graphql`
  fragment FaqCategoryHubFaqData on StrapiComponentFaqCategoryHubFaq {
    topic
    title
    description
    categories {
      ...StrapiSharedLink
    }
  }
`;

function CategoryHubFaq({ data }) {
  if (!data) {
    return <></>;
  }

  return (
    <div className="bg-background-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
        <div>
          {data.topic && (
            <h3 className="text-center text-base font-semibold uppercase tracking-wide text-text-secondary">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.title && (
            <h2 className="text-center text-3xl font-extrabold text-text-primary sm:text-4xl">
              <MarkdownWrapper text={data.title} />
            </h2>
          )}
          {data.description && (
            <MarkdownWrapper
              text={data.description}
              replaceParagraph={false}
              className="mt-4 text-center text-text-secondary"
            />
          )}
        </div>
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Boolean(data.categories?.length) &&
            data.categories.map(
              (category, index) =>
                (category.overwriteTitle || category.link?.title) && (
                  <div
                    key={index}
                    className="w-full cursor-pointer rounded-sm bg-background-off-white p-4 hover:bg-background-secondary-light"
                  >
                    <LinkWrapper
                      to={category.link?.url}
                      className="grid grid-cols-1 gap-4"
                    >
                      <div className="flex h-40 w-full items-center justify-center">
                        {(category.overwriteIcon || category.link?.icon) && (
                          <MediaWrapper
                            media={
                              category.overwriteIcon || category.link?.icon
                            }
                            divClassName="h-full acpect-[1/1]"
                            objectFit="contain"
                          />
                        )}
                      </div>
                      <label className="cursor-pointer text-center text-lg font-semibold text-text-primary">
                        {category.overwriteTitle || category.link?.title}
                      </label>
                    </LinkWrapper>
                  </div>
                )
            )}
        </div>
      </div>
    </div>
  );
}

CategoryHubFaq.propTypes = {
  data: PropTypes.object,
};

export default CategoryHubFaq;
